import { detachDevice as detachDeviceService } from 'services/api/device/detach';
import { rentHistoryDetachDeviceSuccess } from 'action-creators/payway/rentHistory/actionTypes';
import * as constants from './constants';

const detachDevice = payload => async dispatch => {
  const { device_id } = payload;
  dispatch({ type: constants.DETACH, device_id });
  try {
    await detachDeviceService({ device_id });
    dispatch(detachDeviceSuccess({ deviceId: device_id }));
  } catch (error) {
    dispatch(detachDeviceFail({ error }));
  }
};

const detachDevices = devices => async dispatch => {
  dispatch({ type: constants.DETACH_ALL, devices });
  try {
    const promises = devices.map(deviceId => dispatch(detachDevice(deviceId)));
    await Promise.all(promises);
  } catch (error) {
    dispatch(detachDeviceFail({ error }));
  }
};

const detachDeviceByPurchaseSuccess = payload => async dispatch => {
  const { device_id, purchaseId } = payload;
  dispatch({ type: constants.DETACH, device_id });
  try {
    await detachDeviceService({
      device_id,
      id_pago: purchaseId,
    });
    dispatch(rentHistoryDetachDeviceSuccess(payload));
  } catch (error) {
    dispatch(detachDeviceFail({ error }));
  }
};

const detachDevicesByPurchaseSuccess = devices => async dispatch => {
  dispatch({ type: constants.DETACH_ALL, devices });
  try {
    const promises = devices.map(device =>
      dispatch(detachDeviceByPurchaseSuccess(device)),
    );
    await Promise.all(promises);
  } catch (error) {
    dispatch(detachDeviceFail({ error }));
  }
};

const detachDeviceSuccess = payload => dispatch => {
  dispatch({ type: constants.DETACH_SUCCEEDED, payload });
};

const detachDeviceFail = payload => dispatch => {
  dispatch({ type: constants.DETACH_FAILED, payload });
};

export {
  // action creators
  detachDevices,
  detachDevice,
  detachDeviceSuccess,
  detachDeviceByPurchaseSuccess,
  detachDevicesByPurchaseSuccess,
  detachDeviceFail,
};
